// extracted by mini-css-extract-plugin
export default {"dismissButton":"SearchPlatformExternalPlatformTab-module__dismissButton--QbCCn"};